export default __webpack_public_path__ + "static/metal-threads-eb73257f36de3330a23ea4aaa923266b.jpg";